import { Avatar, TextStyle } from '@superops/ui-design-system';
import React from 'react';

const AvatarCell = (props) => {
  const name = props?.cell?.value?.name || props?.cell?.value;
  return (
    <div className="flex actr g5">
      <div className="flex">
        <Avatar initials={name?.[0]} size="extraSmall" />
      </div>
      <div>
        <TextStyle variation={!name && 'subdued'}>{name || 'NA'}</TextStyle>
      </div>
    </div>
  );
};

export default AvatarCell;
